import { SymptomsTranslations } from "./types";

export const deSymptomsTranslations:  SymptomsTranslations = {
    ABDOMINAL_PAIN: "Bauchschmerzen",
    ABNORMAL_SPUTUM: "Auswurf",
    ACOUSTIC_BLACKOUT: "Hörsturz",
    ANKLE_PAIN: "Knöchelschmerzen",
    ANKLE_SWELLING: "Knöchelschwellung",
    ANXIETY: "Angst",
    ARM_PAIN: "Armschmerzen",
    BACK_PAIN: "Rückenschmerzen",
    BREATHLESSNESS: "Luftnot",
    CHEST_PAIN: "Brustschmerzen",
    COLD_LEG: "Kaltes Bein",
    CONFUSION: "Verwirrtheit",
    CONSTIPATION: "Verstopfung",
    COUGH: "Husten",
    DARK_URINE: "Dunkler Urin",
    DEVIATION_FROM_AXIS: "Achsabweichung",
    DIARRHOEA: "Durchfall",
    DOUBLE_IMAGES: "Doppelbilder",
    DYSPHAGIA: "Schluckbeschwerden",
    DYSURIA: "Schmerzen beim Wasserlassen",
    EPISTAXIS: "Nasenbluten",
    EXANTHEMA: "Hautausschlag",
    FACIAL_PARESIS: "einseitige Gesichtslähmung",
    FATIGUE: "Müdigkeit",
    FEVER: "Fieber",
    FLANK_PAIN: "Flankenschmerzen",
    FOCAL_DEFICITS: "fokal-neurologisches Defizit",
    FOCAL_WEAKNESS_ARM: "Armschwäche",
    FOCAL_WEAKNESS_FACE: "einseitige Gesichtslähmung",
    FOCAL_WEAKNESS_LEG: "Beinschwäche",
    FOOT_PAIN: "Fußschmerzen",
    GAZE_PREFERENCES: "Bevorzugte Blickrichtung",
    HAEMATURIA: "Blut im Urin",
    HAEMOPTYSIS: "Bluthusten",
    HAIR_LOSS: "Haarausfall",
    HEAD_CONGESTION: "Kopfschmerzen",
    HEADACHE: "Kopfschmerzen",
    HEARTBURN: "Sodbrennen",
    HEMATOCHEZIA: "Blutauflagerungen auf dem Stuhl",
    HEMIPARESIS: "Halbseitenlähmung",
    HIP_AND_GROIN_PAIN: "Hüft- und Leistenschmerzen",
    HOARSE_VOICE: "Heiserkeit",
    INABILITY_TO_LIFT_LEG: "Unfähigkeit, ein Bein anzuheben",
    INSOMNIA: "Schlafstörungen",
    JAUNDICE: "Gelbsucht",
    JAW_PAIN: "Kieferschmerzen",
    KNEE_PAIN: "Knieschmerzen",
    KNEE_PAIN_IN_OA: "Knieschmerzen",
    LEG_LENGTH_DISCREPANCY: "Beinlängendifferenz",
    LEG_PAIN: "Beinschmerzen",
    LL_MUSCLE_WEAKNESS: "Muscle weakness of the leg",
    LOSS_OF_APPETITE: "Appetitlosigkeit",
    LOSS_OF_CONSCIOUSNESS: "Bewusstlosigkeit",
    MELAENA: "Teerstuhl",
    MEMORY_IMPAIRMENTS: "Gedächtnisstörungen",
    MORNING_STIFFNESS: "Morgensteifigkeit",
    MUMBLING: "Verwaschene Sprache",
    MYALGIA: "Muskelschmerzen",
    MYDRIASIS: "Erweiterte Pupillen",
    MYOPATHY: "Muskelschwäche",
    NAUSEA: "Übelkeit",
    NECK_PAIN: "Nackenschmerzen",
    NECK_STIFFNESS: "Nackensteifigkeit",
    NYKTURIA: "Nächtliches Wasserlassen",
    OSCILLOPSY: "Sehstörung",
    OVERFLOW_INCONTINENCE: "Harninkontinenz",
    PALE_STOOL: "Entfärbter Stuhl",
    PALENESS_OF_THE_LEG: "Blasses Bein",
    PALPITATIONS: "Herzklopfen",
    PARAESTHESIA: "Kribbelparästhesien",
    PHONOPHOBIA: "Geräuschempfindlichkeit",
    PHOTOPHOBIA: "Lichtempfindlichkeit",
    PLUGGED_NOSE: "Verstopfte Nase",
    POLYURIA: "Übermäßige Urinausscheidung",
    PRESYNCOPE: "Kreislaufschwäche",
    PRURITUS: "Juckreiz",
    REDUCED_ANKLE_MOVEMENT: "Eingeschränkte OGS-Beweglichkeit",
    REDUCED_EXERCISE_TOLERANCE: "Verminderte körperliche Belastbarkeit",
    REDUCED_HIP_MOVEMENT: "Eingeschrankte Hüftbeweglichkeit",
    REDUCED_KNEE_MOVEMENT: "eingeschränkte Knie-Beweglichkeit",
    REDUCED_STEP_LENGTH: "Verkürzte Schrittlänge",
    REDUCED_WALKING_DISTANCE: "Verkürzte Gehstrecke",
    REGURGITATION: "Aufstoßen",
    RESTLESSNESS: "Unruhe",
    RUNNY_NOSE: "Laufende Nase",
    SENSORY_AURA: "Sensorische Aura",
    SENSORY_HEMIDEFICIT: "Empfindungsstörung",
    SHAKING_CHILLS: "Schüttelfrost",
    SHOULDER_PAIN_LEFT: "Linksseitige Schulterschmerzen",
    SNEEZING: "Niesen",
    SORE_THROAT: "Halsschmerzen",
    SPEECH_DISTURBANCES: "Verwaschene Sprache",
    STRESS: "Stress",
    SWEATING: "Schwitzen",
    ULCUS_CRURIS_ARTERIOSUM: "Beingeschwür",
    URINARY_RETENTION: "Harnverhalt",
    VAGINAL_BLEEDING: "Vaginale Schmierblutung",
    VERTIGO: "Schwindel",
    VISUAL_AURA: "Visuelle Aura",
    VISUAL_IMPAIRMENT: "Sehstörung",
    VOMITING: "Erbrechen",
    WEIGHT_BEARING_INABILITY: "Unfähigkeit, das eigene Gewicht zu tragen",
    WEIGHT_GAIN: "Gewichtszunahme",
    WEIGHT_LOSS: "Gewichtsverlust",
    WHEEZING: "Giemen",
    WORD_FINDING_DISORDER: "Wortfindungsstörungen",
}